import {
    AUTH_HOST,
    SUMFS_HOST,
    getEnvName
} from '@/config'
import request from '@/service/apiConfig/request'
const originSumfsHost = SUMFS_HOST[getEnvName()]



/** 
 * @description PC选品库分组列表
*/
export const queryMySelectGroups=(params)=>{
    return request.jsonp(originSumfsHost+'/sumis-web/selectCommodityLibrary/private/queryMySelectGroups.do',params)
}

/** 
 * @description 新增产品库
*/
export const addSelectedGroup=(params)=>{
    return request.jsonp(originSumfsHost+'/sumis-web/selectGroup/private/addSelectedGroup.do',params)
}


/** 
 * @description 修改产品库
*/
export const updateMyselectGroup=(params)=>{
    return request.jsonp(originSumfsHost+'/sumis-web/selectGroup/private/updateMyselectGroup.do',params)
}


/** 
 * @description 删除产品库
*/
export const deleteGroup=(params)=>{
    return request.jsonp(originSumfsHost+'/sumis-web/selectGroup/private/deleteGroup.do',params)
}


/** 
 * @description PC选品库查询分组商品详情
*/
export const getCommodityDetailList=(params)=>{
    return request.jsonp(originSumfsHost+'/sumis-web/selectCommodityLibrary/private/getCommodityDetailList.do',params)
}

/** 
 * @description 清空产品库下关联的商品
*/
export const deleteGroupProduct=(params)=>{
    return request.jsonp(originSumfsHost+'/sumis-web/selectGroup/private/deleteGroupProduct.do',params)
}


/** 
 * @description PC选品库商品删除
*/
export const delCommodity=(params)=>{
    return request.jsonp(originSumfsHost+'/sumis-web/selectCommodityLibrary/private/delCommodity.do',params)
}